import { useCallback, useMemo } from 'react';

export const useStatePart = <StateType extends { [key: string]: any }, Key extends keyof StateType>(
    state: StateType,
    setState: (newState: StateType) => any,
    key: Key
): [StateType[Key], (newValue: StateType[Key]) => void] => {
    const value = useMemo(() => {
        return state[key];
    }, [state, key]);

    const getChange = useCallback(
        (newValue: StateType[Key]): StateType => {
            return { ...state, [key]: newValue };
        },
        [state, key]
    );

    const setValue = useCallback(
        (newValue: StateType[Key]) => {
            return setState(getChange(newValue));
        },
        [getChange, setState]
    );

    return [value, setValue];
};
